import type { PropsWithChildren } from 'react';
import {
	loadingPriority,
	useCurrentPriority,
} from '@atlassian/jira-non-critical/src/PriorityManager.tsx';
import { BackgroundPriority } from '@atlassian/jira-non-critical/src/BackgroundPriority.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';

const RenderAfterHydrationCompletionNew = ({ children }: PropsWithChildren) => {
	const tier = useCurrentPriority();
	if (tier < loadingPriority.background) {
		return null;
	}
	return children;
};
export const RenderAfterHydrationCompletion = componentWithCondition(
	() => fg('jfp-magma-fix-hydration-completion'),
	RenderAfterHydrationCompletionNew,
	BackgroundPriority,
);
